import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const createUser = createAsyncThunk(
  'users/createUser',
  catchAsync(async (data, thunkAPI) => {
    const res = await axios.post('/users', data);
    return res.data;
  })
);
